module.exports = __webpack_public_path__ + "img/EE11056860.567dc345.png";